import trySaveMessage from '../actions/trySaveMessage';
import upConvert from '../actions/upConvert';
import { moveComposeToTab } from '../lazyIndex';
import { ComposeViewState, GroupComposeViewState } from 'owa-mail-compose-store';
import { isSxSDisplayed, lazyOpenComposeInSxS } from 'owa-sxs-store';

// VSO 16069 [Mac/Safari] After set importance, then typing, the cursor is not at the end.
// This is a workaround to fix the focus issue in Edge and Mac Safari
export default async function upConvertHelper(composeViewState: ComposeViewState) {
    // In Group scenario, message is not saved in draft when user clicks ReplyAll, so Quoted body for the message is not available
    // Save the group message when expanding to get the quoted body.
    if (
        (composeViewState as GroupComposeViewState).groupId != null &&
        (!composeViewState.itemId || composeViewState.isDirty)
    ) {
        await trySaveMessage(composeViewState);
    }

    if (isSxSDisplayed()) {
        upConvert(composeViewState);
        const openComposeInSxS = await lazyOpenComposeInSxS.import();
        openComposeInSxS(composeViewState);
    } else {
        moveComposeToTab(composeViewState, true /*isShown*/, true /*makeActive*/);
    }
}
